import React, { createContext, useContext } from 'react';
import { useId } from '../hooks/use-id';
export const UniqueIdContext = /*#__PURE__*/createContext(undefined);
export const UniqueIdContextProvider = _ref => {
  let {
    children
  } = _ref;
  const uniqueId = useId().split('-')[0];
  return /*#__PURE__*/React.createElement(UniqueIdContext.Provider, {
    value: uniqueId
  }, children);
};
export function useUniqueId() {
  const context = useContext(UniqueIdContext);
  if (context === undefined) {
    throw new Error('useUniqueId must be used within a UniqueIdProvider');
  }
  return context;
}
//# sourceMappingURL=unique-id-context.js.map